<template>
  <section class="hero">
      <div class="hero__content container">
        <div class="hero__content--info">
          <h1 class="hero__title">
            Sequire Investor Summit
          </h1>
          <h2 class="hero__date">
            Thank you!
          </h2>
          <h3 class="hero__location">
            We look forward to seeing you in 2025!
          </h3>
        </div>
        <iframe 
          class="hero__content--video"
          width="520" 
          height="247" 
          src="https://www.youtube.com/embed/5on-MZ2jYPk?si=lZWQThqmE4R5dUsZ&amp;controls=0" 
          title="YouTube video player" 
          frameborder="0" 
          allow="accelerometer; 
          autoplay; 
          clipboard-write; 
          encrypted-media; 
          gyroscope; 
          picture-in-picture" 
          allowfullscreen>
        </iframe>
      </div>
    </section>
  </template>
  
  <script>

  export default {
    name: 'Hero',
    data () {
      return {
      }
    },
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style lang="scss" scoped>
  @import "../styles/components/hero.scss";
  </style>